function getDeviceStatus(stream?: VideoStream): { color: string, message: string } {
  if (stream?.statusOnDevice === 'online') return { color: "#107145", message: 'Online' };
  else if (stream?.statusOnDevice === 'offline') return { color: "#aa0000", message: 'Offline' };
  else if (stream?.statusOnDevice === 'invalid_configuration') return { color: "#bbbb00", message: 'Invalid Configuration' };
  else if (stream?.statusOnDevice === 'invalid_rtsp') return { color: "#bbbb00", message: 'Invalid RTSP' };
  else return { color: "#bbbb00", message: 'Unknown' };
}

export default getDeviceStatus;
